const id = 'asset-tracking';
const name = 'Asset Tracking';

const publish = [
  {
    lang: 'java',
    name: 'Android',
    code: `val publisher = Publisher.publishers()
  .connection(ConnectionConfiguration(Authentication.basic('{{CLIENT_ID}}', '{{API_KEY}}')))
  .map(MapConfiguration({MAPBOX_ACCESS_TOKEN}))
  .androidContext(this)
  .resolutionPolicy(DefaultResolutionPolicyFactory(defaultResolution, this))
  .profile(RoutingProfile.DRIVING)
  .start()
publisher.track(Trackable(trackingId, constraints = exampleConstraints ))`,
  },
  {
    lang: 'swift',
    name: 'iOS/Swift',
    code: `let publisher = try PublisherFactory.publishers()
  .connection(ConnectionConfiguration(apiKey: '{{API_KEY}}', clientId: '{{CLIENT_ID}}'))
  .log(LogConfiguration())
  .transportationMode(TransportationMode())
  .delegate(self)
  .start();

publisher.track(Trackable( trackingId, constraints = exampleConstraints ))`,
  },
];

const subscribe = [
  {
    lang: 'java',
    name: 'Android',
    code: `val subscriber = Subscriber.subscribers()
  .connection(ConnectionConfiguration(Authentication.basic('{{CLIENT_ID}}', '{{API_KEY}}')))
  .resolution(Resolution(Accuracy.MAXIMUM, desiredInterval = 1000L, minimumDisplacement = 1.0))
  .trackingId(trackingId)
  .start()
subscriber.locations.onEach { }.launchIn(scope)`,
  },
  {
    lang: 'swift',
    name: 'iOS/Swift',
    code: `let subscriber = SubscriberFactory.subscribers()
  .connection(ConnectionConfiguration(apiKey: '{{API_KEY}}', clientId: '{{CLIENT_ID}}'))
  .trackingId(trackingId)
  .routingProfile(.driving)
  .log(LogConfiguration())
  .resolution(Resolution(accuracy: .maximum, desiredInterval: 10000, minimumDisplacement: 500))
  .delegate(self)
  .start();

if let location = self.location { print("Location update received. Coordinates: (location.coordinate)"); }`,
  },
  {
    lang: 'javascript',
    name: 'JavaScript',
    code: `import { Subscriber, Accuracy } from '@ably/asset-tracking';

const ablyOptions = { key: '{{API_KEY}}', clientId: '{{CLIENT_ID}}', }
const subscriber = new Subscriber({
  ablyOptions, onLocationUpdate, onStatusUpdate,
});

await subscriber.start(trackingId);

subscriber.onLocationUpdate((locationUpdate) => {
  console.log(\`Location update received. Coordinates: \${locationUpdate.location.geometry.coordinates}\`);
})`,
  },
];

export default {
  id,
  name,
  data: { publish, subscribe },
};
